class mixStorage {
  constructor() {
    this.storage = localStorage
  }
  setItem(key, value) {
    this.storage.setItem(key, value);
  }
  getItem(key) {
    return this.storage.getItem(key);
  }
  retrieve(key) {
    let item = this.storage.getItem(key)
    if (item && item !== 'undefined') {
      return JSON.parse(this.storage.getItem(key))
    }
    return ''
  }
  store(key, value) {
    this.storage.setItem(key, JSON.stringify(value))
  }

  removeItem(key) {
    this.storage.removeItem(key)
  }
}

const storage = new mixStorage();

export default storage; 



// WEBPACK FOOTER //
// ./src/common/storage.js